<template>
  <main class="home">
    <Header />
    <hr class="m-0 p-0" />
    <ConfirmDeleteVirtual />
  </main>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import Header from "@/shared-components/consumer/Header.vue";
import ConfirmDeleteVirtual from "@/apps/credit-line/components/CreditCard/ConfirmDeleteVirtualCard.vue";
import { setLanguage } from "@/apps/credit-line/helpers/translations.helper";

export default defineComponent({
  name: "CreditCardConfirmDeleteView",
  components: {
    ConfirmDeleteVirtual,
    Header,
  },
  beforeMount() {
    setLanguage(this);
  },
});
</script>

<style lang="scss" scoped>
@import "@/assets/scss/_constants.scss";
</style>
